var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 0.942871H3.5C1.835 0.942871 0.5 2.29287 0.5 3.94287V24.9429C0.5 26.5929 1.85 27.9429 3.5 27.9429H9.5L12.935 31.3779C13.52 31.9629 14.465 31.9629 15.05 31.3779L18.5 27.9429H24.5C26.15 27.9429 27.5 26.5929 27.5 24.9429V3.94287C27.5 2.29287 26.15 0.942871 24.5 0.942871ZM14 5.89287C16.235 5.89287 18.05 7.70787 18.05 9.94287C18.05 12.1779 16.235 13.9929 14 13.9929C11.765 13.9929 9.95 12.1779 9.95 9.94287C9.95 7.70787 11.765 5.89287 14 5.89287ZM5 20.5929V21.9429H23V20.5929C23 17.5929 17 15.9429 14 15.9429C11 15.9429 5 17.5929 5 20.5929Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPin);
export default __webpack_public_path__ + "static/media/person-pin.d80dc035.svg";
export { ForwardRef as ReactComponent };